import type { TFunction } from "i18next";

export interface SelectOption {
  value: string;
  label: string;
}

export function getVehicleTypeOptions(t: TFunction): SelectOption[] {
  return [
    { value: "car", label: t("units.type.car", { defaultValue: "Auto" }) },
    { value: "truck", label: t("units.type.truck", { defaultValue: "Camión" }) },
    { value: "trailer", label: t("units.type.trailer", { defaultValue: "Remolque" }) },
    { value: "pickup", label: t("units.type.pickup", { defaultValue: "Pickup" }) },
    { value: "van", label: t("units.type.van", { defaultValue: "Van" }) },
    { value: "suv", label: t("units.type.suv", { defaultValue: "SUV" }) },
    { value: "other", label: t("units.type.other", { defaultValue: "Otro" }) },
  ];
}

export function getFuelTypeOptions(t: TFunction): SelectOption[] {
  return [
    { value: "gasoline", label: t("units.fields.gasoline", { defaultValue: "Gasolina" }) },
    { value: "diesel", label: t("units.fields.diesel", { defaultValue: "Diésel" }) },
    { value: "electric", label: t("units.fields.electric", { defaultValue: "Eléctrico" }) },
    { value: "hybrid", label: t("units.fields.hybrid", { defaultValue: "Híbrido" }) },
    { value: "lpg", label: t("units.fields.lpg", { defaultValue: "GLP" }) },
    { value: "cng", label: t("units.fields.cng", { defaultValue: "GNC" }) },
  ];
}

export function getTrailerTypeOptions(t: TFunction): SelectOption[] {
  return [
    { value: "dry_van", label: t("trailers.fields.type.dry_van", { defaultValue: "Caja seca" }) },
    { value: "refrigerated", label: t("trailers.fields.type.refrigerated", { defaultValue: "Refrigerado" }) },
    { value: "flatbed", label: t("trailers.fields.type.flatbed", { defaultValue: "Plataforma" }) },
    { value: "tank", label: t("trailers.fields.type.tank", { defaultValue: "Pipa" }) },
    { value: "lowboy", label: t("trailers.fields.type.lowboy", { defaultValue: "Lowboy" }) },
    { value: "container", label: t("trailers.fields.type.container", { defaultValue: "Contenedor" }) },
    { value: "dump", label: t("trailers.fields.type.dump", { defaultValue: "Volquete" }) },
    { value: "car_carrier", label: t("trailers.fields.type.car_carrier", { defaultValue: "Porta autos" }) },
  ];
}

export function getTrailerConditionOptions(t: TFunction): SelectOption[] {
  return [
    { value: "excellent", label: t("trailers.fields.condition.excellent", { defaultValue: "Excelente" }) },
    { value: "good", label: t("trailers.fields.condition.good", { defaultValue: "Bueno" }) },
    { value: "fair", label: t("trailers.fields.condition.fair", { defaultValue: "Regular" }) },
    { value: "poor", label: t("trailers.fields.condition.poor", { defaultValue: "Malo" }) },
  ];
}

export function getTrailerBrakeTypeOptions(t: TFunction): SelectOption[] {
  return [
    { value: "air", label: t("trailers.fields.brakeType.air", { defaultValue: "Aire" }) },
    { value: "hydraulic", label: t("trailers.fields.brakeType.hydraulic", { defaultValue: "Hidráulico" }) },
    { value: "electric", label: t("trailers.fields.brakeType.electric", { defaultValue: "Eléctrico" }) },
    { value: "abs", label: t("trailers.fields.brakeType.abs", { defaultValue: "ABS" }) },
  ];
}

export function getTrailerSuspensionTypeOptions(t: TFunction): SelectOption[] {
  return [
    { value: "air", label: t("trailers.fields.suspensionType.air", { defaultValue: "Aire" }) },
    { value: "spring", label: t("trailers.fields.suspensionType.spring", { defaultValue: "Muelles" }) },
    { value: "mechanical", label: t("trailers.fields.suspensionType.mechanical", { defaultValue: "Mecánica" }) },
  ];
}
